__webpack_require__.p = "/sl/assets/";